import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WorkOrders_ds_work_order_completed_tasks_count_widgetService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { workOrderId: number }): 
  Promise<{ result: { ActualCount?: number, WorkOrderId?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.workOrderId)) {
      missingRequiredInParams.push('\'workOrderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WorkOrders/datasources/ds_work_order_completed_tasks_count_widget/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      workOrderId: number    }) {
        if(isNil(inParams.workOrderId)) {
          return true; 
        }
      return false;
    }
}
